import { DONATION_BNB_TOAST_ITEMS } from '@/app/donation/constants';
import { DONATION_ROUTES } from '@/constants';

//* 고기부 홈은 내비 항목에서 빠졌지만 「+」 메뉴로 돌아오는 진입점이라 내비를 유지한다
const FLOATING_BNB_DONATION_PATHS = new Set<string>([
  DONATION_ROUTES.HOME.pathname,
  ...DONATION_BNB_TOAST_ITEMS.map(({ route }) => route.pathname),
]);

export type FloatingBnbKind = 'donation';

export const getFloatingBnbKind = (
  pathname: string | null | undefined,
): FloatingBnbKind | null => {
  if (!pathname) return null;
  if (FLOATING_BNB_DONATION_PATHS.has(pathname)) return 'donation';

  return null;
};
